import React from 'react';
import {Icon } from 'antd';

export default <Icon className="spin-loader-icon" type="loading-3-quarters" spin />;
